import { RequestService } from '../../../../../common/services/RequestService';
import { USER_SEARCH_VEHICLES_GET } from '../../constants';

export const getUserSearchVehiclesRequest = payload => {
  return RequestService.get(
    `${USER_SEARCH_VEHICLES_GET}?search_entry=${payload}`
  );
};
